import angular from 'angular';
import moment from 'moment';

class containerCtrl {
  /* @ngInject */
  constructor(
    $scope,
    $filter,
    $translate,
    uiGridExporterConstants,
    AuthSvc,
    i18nService,
    ContainerService,
    LadProviderService,
    PrincipalSvc,
    ContainersFilter,
    LANGUAGES,
    uiGridConstants,
    CompanyService
  ) {
    this.$scope = $scope;
    this.$filter = $filter;
    this.$translate = $translate;
    this.uiGridExporterConstants = uiGridExporterConstants;
    this.AuthSvc = AuthSvc;
    this.i18nService = i18nService;
    this.ContainerService = ContainerService;
    this.LadProviderService = LadProviderService;
    this.PrincipalSvc = PrincipalSvc;
    this.ContainersFilter = ContainersFilter;
    this.LANGUAGES = LANGUAGES;
    this.uiGridConstants = uiGridConstants;
    this.CompanyService = CompanyService;
  }

  $onInit() {
    this.i18nService.setCurrentLang(this.$translate.use());
    // Accès raccourcis aux autorisations depuis le scope principal
    this.isAuthorized = this.AuthSvc.isAuthorized;

    this.ladProviders = this.LadProviderService.findAll();
    this.languages = this.LANGUAGES;
    this.criteriaCO = new this.ContainersFilter();
    this.initContainersSearchFilter();

    this.$scope.includes = {
      formMessages: require('../../../common/form-messages.html')
    };

    var defaultCellTemplate =
      '<a class="grid-cell-link" ui-sref="app.principal.consult.updatecontainer({ id : row.entity.principalId, mode: \'details\', containerId: row.entity.containerId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.view(row)">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
    var translatedCellTemplate =
      '<a class="grid-cell-link" ui-sref="app.principal.consult.updatecontainer({ id : row.entity.principalId, mode: \'details\', containerId: row.entity.containerId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.view(row)">{{COL_FIELD | translate}}</div></a>';
    var containerModeCellTemplate =
      '<a class="grid-cell-link" ui-sref="app.principal.consult.updatecontainer({ id : row.entity.principalId, mode: \'details\', containerId: row.entity.containerId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.view(row)">{{"container_mode." + COL_FIELD | translate}}</div></a>';

    this.containersGridOptions = {
      columnDefs: [
        {
          name: 'DoEidWithId',
          displayName: 'principal.container.column.principal.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          sort: { direction: this.uiGridConstants.ASC, priority: 0 }
        },
        {
          name: 'companyId',
          displayName: 'principal.container.column.company.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          type: 'number'
        },
        {
          name: 'companyName',
          displayName: 'principal.container.column.company.name',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          sort: { direction: this.uiGridConstants.ASC, priority: 1 }
        },
        {
          name: 'containerId',
          displayName: 'principal.container.column.container.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          sort: { direction: this.uiGridConstants.ASC, priority: 2 },
          type: 'number'
        },
        {
          name: 'containerType',
          displayName: 'principal.container.column.container.type',
          cellTemplate: translatedCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'containerMode',
          displayName: 'dashboard.column.envelope.application',
          cellTemplate: containerModeCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'dematMode',
          displayName: 'principal.container.column.container.dematMode',
          cellTemplate: translatedCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'mappingFilename',
          displayName: 'principal.container.column.container.treatment',
          cellTemplate: translatedCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'containerName',
          displayName: 'principal.container.column.container.name',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'containerStatus',
          displayName: 'principal.container.column.container.status',
          cellTemplate: translatedCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'language',
          displayName: 'principal.container.column.container.language',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'authorized',
          displayName: 'principal.container.column.authorized',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          enableSorting: false
        },
        {
          name: 'nonAuthorized',
          displayName: 'principal.container.column.nonAuthorized',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          enableSorting: false
        },
        {
          name: 'ladProviderName',
          displayName: 'principal.container.column.ladProviderName',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        }
      ],
      enableGridMenu: false,
      enableRowSelection: true,
      enableColumnMenus: false,
      enableSelectAll: true,
      selectionRowHeaderWidth: 30,
      exporterMenuCsv: true,
      exporterMenuPdf: false,
      exporterCsvColumnSeparator: ';',
      exporterOlderExcelCompatibility: true,
      exporterHeaderFilter: this.$translate.instant,
      gridMenuTitleFilter: this.$translate,
      exporterFieldCallback: (grid, row, col, value) => {
        if (
          col.name === 'containerType' ||
          col.name === 'dematMode' ||
          col.name === 'traitementType' ||
          col.name === 'containerStatus'
        ) {
          value = this.$translate.instant(value);
        } else if (col.name === 'containerMode') {
          value = this.$translate.instant('container_mode.' + value);
        }
        return value;
      },
      onRegisterApi: gridApi => {
        this.gridContainersApi = gridApi;
      }
    };

    var containerHistorySearchCriteria = this.PrincipalSvc.getContainerListFilter();
    if (containerHistorySearchCriteria) {
      this.criteriaCO = containerHistorySearchCriteria;
    }

    // Check if all fields are empty to disable search on init.
    if(!Object.values(this.criteriaCO).every(criteria => criteria === null)){
        this.searchContainers();
    }
  }

  clearSearchContainers() {
    this.initContainersSearchFilter();
    this.containersGridOptions.data = this.ContainerService.searchByCriterias(this.criteriaCO, data => {
      this.updateContainersCells(data);
    });
  }

  searchContainers() {
    this.cleanContainersFormParam();
    this.PrincipalSvc.setContainerListFilter(this.criteriaCO);
    this.containersGridOptions.data = this.ContainerService.searchByCriterias(this.criteriaCO, data => {
      this.updateContainersCells(data);
    });
    this.containerPromise = this.containersGridOptions.data.$promise;
  }
  // Exporter le tableau
  exportCsv() {
    this.containersGridOptions.exporterCsvFilename = 'containers_' + moment().format('DDMMYYYY') + '.csv';
    this.containersGridOptions.exporterHeaderFilter = this.$translate.instant;
    this.gridContainersApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
  }

  translatedLanguage(language) {
    return this.$filter('translate')(language);
  }

  updateContainersCells(data) {
    var gridData = this.containersGridOptions.data;
    if (gridData.length === 0) {
      return;
    }

    var countDepositorCriteria = [];
    angular.forEach(data, (value /*, key*/) => {
      countDepositorCriteria.push(value.containerId);
    });
    this.ContainerService.countContainer(countDepositorCriteria, countedDepositor => {
      for (var i = 0; i < gridData.length; i++) {
        for (var j = 0; j < countedDepositor.length; j++) {
          if (countedDepositor[j].containerId == gridData[i].containerId) {
            gridData[i].authorized = countedDepositor[j].nbDepositorAllowed;
            gridData[i].nonAuthorized = countedDepositor[j].nbDepositorBlacklist;
            break;
          }
        }
      }
    });

    // Construit un nom fictif de nom de fichier de mapping pour les mappings génériques
    var genMappings = { P: 'Générique PASREL', G: 'Générique GIS' };
    for (var i = 0; i < gridData.length; i++) {
      if (!gridData[i].mappingFilename) {
        gridData[i].mappingFilename = genMappings[gridData[i].dematPlatformId];
      }
    }
  }

  cleanContainersFormParam() {
    if (this.criteriaCO.containerType == '') {
      this.criteriaCO.containerType = undefined;
    }
    if (this.criteriaCO.containerMode == '') {
      this.criteriaCO.containerMode = undefined;
    }
    if (this.criteriaCO.dematMode == '') {
      this.criteriaCO.dematMode = undefined;
    }
    if (this.criteriaCO.containerStatus == '') {
      this.criteriaCO.containerStatus = undefined;
    }
    if (this.criteriaCO.traitementType == '') {
      this.criteriaCO.traitementType = undefined;
    }
  }

  initContainersSearchFilter() {
    this.criteriaCO = new this.ContainersFilter();
  }

  getNameIdentifier(val) {
    return this.CompanyService.autocompleteNameId({ data: val }).$promise.then(result => {
      return result;
    });
  }

  getTableHeight(gridApi) {
    var rowHeight = 30;
    var headerHeight = 30;
    var scrollHeight = 20;
    var footerHeight = 32;
    return {
      height:
        gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight + headerHeight + scrollHeight + footerHeight + 'px'
    };
  }
}

angular.module('principal').component('container', {
  templateUrl: require('./container.html'),
  controller: containerCtrl,
  bindings: {}
});
